import { fetchSanityData } from "@/lib/sanity";

export const fetchCommentsByPostId = async (postId: string) => {
  const query = `*[_type == "comment" && post._ref == $postId] | order(timestamp asc) {
    _id,
    authorName,
    commentText,
    timestamp,
    
  }`;

  try {
    const comments = await fetchSanityData(query, { postId });
    return comments || [];
  } catch (error) {
    console.error("Error fetching comments:", error);
    return [];
  }
};
